/**
 * Copies text to clipboard
 */
export const copyToClipboard = async (text: string): Promise<void> => {
  if (!navigator?.clipboard?.writeText) {
    throw new Error('Clipboard API not supported');
  }

  await navigator.clipboard.writeText(text);
};
